import { render, staticRenderFns } from "./OwnersNewsletterEdit.vue?vue&type=template&id=0f96b43e&scoped=true&"
import script from "./OwnersNewsletterEdit.vue?vue&type=script&lang=js&"
export * from "./OwnersNewsletterEdit.vue?vue&type=script&lang=js&"
import style0 from "./OwnersNewsletterEdit.vue?vue&type=style&index=0&id=0f96b43e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f96b43e",
  null
  
)

export default component.exports